<template>
    <div class="input-group input-group-flush input-group-merge">
        <input
            type="search"
            id="searchBar"
            autocomplete="off"
            class="form-control form-control-prepended dropdown-toggle search"
            data-toggle="dropdown"
            :placeholder="$t('Search')"
            v-model="query"
            aria-label="Search"
        />
        <div class="input-group-prepend">
            <div class="input-group-text">
                <i v-if="areCustomersLoading" class="fe fe-loader spin-icon"></i>
                <i
                    v-else-if="!areCustomersLoading && query"
                    @click="query=null; searchResults=[]"
                    class="pointer fe fe-x"
                ></i>
                <i v-else class="fe fe-search"></i>
            </div>
        </div>

        <!-- Menu -->
        <div class="dropdown-menu dropdown-menu-card show" v-if="query">
            <div class="card-body p-0" v-if="searchResults.length>0">
                <div class="list-group list-group-flush list" @click="query=null; searchResults=[]">
                    <router-link
                        :to="{name:'people.customer', params:{id:customer._id}}"
                        class="list-group-item p-2"
                        :class="{'active':idx == currentFocus}"
                        v-for="(customer, idx) in searchResults"
                        :key="idx"
                    >
                        <div class="row align-items-center p-1 m-0">
                            <div class="col-auto">
                                <avatar
                                    v-if="customer.avatar"
                                    :src="customer.avatar.preview"
                                    :color="customer.color"
                                    :userName="{ first_name: customer.first_name, last_name: customer.last_name }"
                                    type="circle"
                                    size="avatar-sm"
                                    textSize="h4"
                                ></avatar>
                            </div>
                            <div class="col ml-n2">
                                <h4 class="text-body mb-1 name">{{ customer.first_name }} {{ customer.last_name }}</h4>

                                <p class="small text-muted mb-0">
                                    <span class="fe fe-phone"></span>
                                    {{ customer.phone }}
                                </p>
                                <tag-pills :tags="customer.tags" />
                            </div>
                        </div>
                        <!-- / .row -->
                    </router-link>
                </div>
            </div>
            <div class="card-body" v-else>
                <span v-if="areCustomersLoading">{{ $t('Searching') }}...</span>
                <span v-else>{{ $t('Nothing found') }}</span>
            </div>
        </div>

        <!-- / .dropdown-menu -->
    </div>
</template>


<script>
import Avatar from '@/components/Avatar.vue';
import TagPills from '@/components/TagPills.vue';
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';

export default {
    props: ['searchActive'],
    components: {
        TagPills,
        Avatar
    },
    data() {
        return {
            autofocus: false,
            currentFocus: 0,
            query: null,
            params: {
                query: {
                    $limit: 20,
                    $sort: {
                        createdAt: -1
                    }
                }
            },
            searchResults: [],
            pendingPromise: null
        }
    },
    destroyed() {
        window.removeEventListener("keyup", this.listener, true);
    },
    created() {
        window.addEventListener('keyup', this.listener, true);
        // window.addEventListener('keyup', (event) => {
        //     if (event.srcElement.tagName !== 'BODY') return;
        //     if (event.keyCode == 191) {
        //         this.autofocus = true;
        //     }

        // });
    },
    computed: {
        ...mapState('customers', { areCustomersLoading: 'isFindPending' }),
    },
    watch: {
        query: {
            handler: debounce(async function (newVal) {
                if (newVal) {
                    this.params.query = { ...this.params.query, ...this.$customersSearch(newVal) };
                } else {
                    delete this.params.query.$or;
                    delete this.params.query.first_name;
                    delete this.params.query.last_name;
                    delete this.params.query.phone;
                }
                if (this.pendingPromise)
                    await this.pendingPromise
                this.searchResults = []
                this.pendingPromise = this.findItems();

            }, 300),
            deep: true
        },
        query1(newValue) {
            console.log('another', newValue);

            if (newValue) {

                // this.params.query.$text = {
                //     $search: newValue,
                // };
                // this.params.query.$select = {
                //     score: {
                //         $meta: "textScore"
                //     }
                // };
                // this.params.query.$sort = { score: { $meta: "textScore" } };

                this.params.query.$or = [
                    { first_name: { $regex: newValue, $options: "i" } },
                    { last_name: { $regex: newValue, $options: "i" } },
                    { phone: { $regex: newValue, $options: "i" } },
                ]
            } else {
                delete this.params.query.$text;
                delete this.params.query.$select;
                delete this.params.query.$sort;
            }

            this.findItems();
        }
    },
    methods: {
        ...mapActions('customers', ['find']),
        ...mapMutations('customers', {
            clearCustomers: 'clearAll'
        }),

        listener(event) {
            if (event.keyCode == 40) this.currentFocus++;
            else if (event.keyCode == 38) this.currentFocus--;
            else if (event.keyCode == 27) {
                this.query = null;
                document.activeElement.blur();

            } else if (event.keyCode == 13 && this.query) {
                this.query = null;
                document.activeElement.blur();
                this.$router.push({ name: 'people.customer', params: { id: this.searchResults[this.currentFocus]._id } });
            }

            if (this.currentFocus < 0) this.currentFocus = this.searchResults.length - 1;
            if (this.currentFocus > this.searchResults.length - 1) this.currentFocus = 0;

        },
        findItems() {
            return this.find(this.params).then(data => {
                this.searchResults = data.data;
            });
        },


    }

}
</script>

<style scoped>
.active .name, .active .text-muted {
    color: white !important;
}

</style>
